import { Box, Image, Button, Text } from '@chakra-ui/react';
import { ErrorPageBg, ErrorPageBeat, ErrorPageLogo, ErrorPageBall } from '@laliga-cdac/assets';
import { createElement } from 'react';
import { em } from 'polished';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["backgroundSrc"];
var device = {
  mobile: '@media(max-width: 420px)'
};
/** el caracter '@' será sustituído por el icono del balón */

var codes = {
  401: '4@1',
  403: '4@3',
  404: '4@4',
  500: '5@5',
  oops: 'O@PS'
};

var ErrorPage = function ErrorPage(props) {
  var backgroundSrc = props.backgroundSrc,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  return createElement(Box, {
    pos: "relative",
    w: "full",
    h: "100vh",
    d: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    bgColor: "white",
    _before: {
      display: 'block',
      content: "''",
      background: "url(" + (backgroundSrc || ErrorPageBg) + ") no-repeat top center",
      bgSize: 'cover',
      position: 'absolute',
      width: 'full',
      height: 'full',
      opacity: '0.25',
      zIndex: 1
    },
    sx: {
      '& > *': {
        zIndex: 2
      }
    }
  }, createElement(Beat, null), createElement(Content, Object.assign({}, rest)), createElement(Beat, {
    isReverse: true
  }));
};

var Beat = function Beat(props) {
  var isReverse = props.isReverse;
  return createElement(Image, {
    src: ErrorPageBeat,
    w: "full",
    transform: isReverse ? 'rotate(180deg)' : '',
    alt: "",
    "data-testid": "beats-img-test-id"
  });
};

var Content = function Content(props) {
  var _sx, _sx2, _sx5;

  var logoSrc = props.logoSrc,
      disableBall = props.disableBall,
      code = props.code,
      title = props.title,
      description = props.description,
      children = props.children,
      buttonFunc = props.buttonFunc;
  var errorCode = code ? codes[code] : codes.oops;

  var goBack = function goBack() {
    return window.location.href = '/';
  };

  return createElement(Box, {
    textAlign: "center"
  }, createElement(Image, {
    src: logoSrc || ErrorPageLogo,
    w: "full",
    alt: "",
    m: "auto",
    marginBottom: em('62px'),
    sx: (_sx = {}, _sx[device.mobile] = {
      w: "" + em('240px')
    }, _sx)
  }), createElement(Box, {
    mb: em('32px'),
    textAlign: "center",
    display: "inline-flex",
    alignItems: "center"
  }, disableBall ? createElement(Span, {
    fontSize: em('96px'),
    sx: (_sx2 = {}, _sx2[device.mobile] = {
      fontSize: "" + em('72px')
    }, _sx2)
  }, code || 'oops') : Array.from(errorCode).map(function (letter) {
    var _sx3, _sx4;

    return letter === '@' ? createElement(Image, {
      w: em('81px'),
      h: em('81px'),
      verticalAlign: "middle",
      key: Math.random(),
      src: ErrorPageBall,
      alt: "",
      sx: (_sx3 = {}, _sx3[device.mobile] = {
        w: "" + em('60px'),
        h: "" + em('60px'),
        bottom: "" + em('22px')
      }, _sx3)
    }) : createElement(Span, {
      fontSize: em('96px'),
      key: Math.random(),
      sx: (_sx4 = {}, _sx4[device.mobile] = {
        fontSize: "" + em('72px')
      }, _sx4)
    }, letter);
  })), createElement(Span, {
    fontSize: em('30px'),
    fontWeight: "bold",
    textTransform: "uppercase",
    lineHeight: "1.35",
    mb: em('8px'),
    sx: (_sx5 = {}, _sx5[device.mobile] = {
      fontSize: "" + em('24px')
    }, _sx5)
  }, title), createElement(Span, {
    lineHeight: "1.45",
    marginBottom: "30px"
  }, description), children || createElement(Button, {
    onClick: buttonFunc || goBack
  }, "Volver al inicio"));
};

var Span = function Span(props) {
  return createElement(Text, Object.assign({
    color: "#25282a"
  }, props), props.children);
};

export default ErrorPage;